<template>
  <main class="home page" :style="{'background-image': 'url(' + details.intro_image +')'}">
    <section class="mainContent">
      <sectionHeader/>
      <h1 v-html="details.quiz_title "></h1><!-- {{quiz.title}} -->
      <h3 class="baseline">Les métiers de la transition écologique</h3>
      <div class="quiz-buttons">
        <router-link to="/questions" @click="setCountry('ch')"  class="btn">Démarrer le Quiz 🇨🇭</router-link>
        <router-link to="/questions" @click="setCountry('fr')"  class="btn">Démarrer le Quiz 🇫🇷</router-link>
        
      </div>
      <div class="partenaires" v-if="details.logo_partenaires != 0">
          <div class="partenaire" v-for="(partenaire,index) in details.logo_partenaires" :key="index">
            <a :href="partenaire.lien_partenaire" target="_blank"><img :src="partenaire.logo_partenaire.sizes.large" alt=""></a>
          </div>
      </div>
    </section>
  </main>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
// import quizLogo from '@/components/quizLogo.vue'
import sectionHeader from '@/components/sectionHeader.vue'

export default {
  name: 'Home',
  data () {
    return {
    }
  },
  components: {
    sectionHeader
  },
  computed: {
    details () {
      return this.$store.state.details
    },
    selectedCountry () {
      return this.$store.state.selectedCountry
    }
  },

  methods: {
    setCountry (country) {
      this.$store.commit('SET_COUNTRY', country)
    }
  }
}
</script>

<style lang="scss">
  .home {
    background: no-repeat center center;
    background-size: cover;

    .section-header {

      @media all and (max-width: 1366px) {
        margin-bottom: 100px;
      }

      @media all and (max-width: 768px) {
        margin-bottom: 100px;
        //font-size: 12px;
      }

      @media all and (max-width: 540px) {
        margin-bottom: 60px;
      }

      .quiz_title {
        border-top: #fff 1px solid;
        //width: calc(100% - 20px);
        //margin-top: 0;
        color: #fff;
        //content: '';

        @media all and (max-width: 540px) {
          //margin-top: 14px;
          //width: calc(100% - 0px);
        }
      }

      #headericon {
        fill: #fff;
        width: 60px;

        @media all and (max-width: 540px) {
          width: 30px;
        }
      }
    }

    h1 {
      color: #fff;
      max-width: inherit;

       @media all and (max-width: 1024px) {
         br {
           display: none;
         }
       }

       @media all and (max-width: 1366px) {
         font-size: 45px;
       }

       @media all and (max-width: 540px) {
         font-size: 35px;
       }
    }

    h3.baseline {
        font-family: 'Titillium Web', sans-serif;
        font-weight: 300;
        color: #fff;
        text-transform: uppercase;
        font-size: 32px;

        @media all and (max-width: 1014px) {
          margin-top: 10px;
        }

        @media all and (max-width: 690px) {
         font-size: 25px;
       }

       @media all and (max-width: 540px) {
         font-size: 20px;
       }
      }
    .quiz-buttons {
       margin-top: 100px;
       column-gap: 20px;
       display: flex;

       @media all and (max-width: 780px) {
          column-gap: 10px;
       }

      @media all and (max-width: 768px) {
        margin-top: 80px;
        margin-bottom: auto;
      }

      .btn {
        border-color: #fff;
        color: #fff;

        @media all and (max-width: 1366px) {
          font-size: 25px;
        }

        @media all and (max-width: 690px) {
         font-size: 18px;
        }

        @media all and (max-width: 480px) {
          font-size: 16px;
          padding: 5px 10px;
        }

        &:hover {
          background-color: #fff;
          color: #000;
        }
      }
    }
    .partenaires {
      display: flex;
      flex-direction: row;
      align-items: center;
      flex-wrap: wrap;
      justify-content: flex-end;
      max-width: 950px;
      margin-top: 100px;
      column-gap: 40px;
      row-gap: 20px;

      @media all and (max-width: 1366px) {
        max-width: 750px;
      }


      @media all and (max-width: 540px) {
        //flex-direction: column;
        justify-content:center;
        align-items: center;
        padding-bottom: 40px;
      }

      .partenaire {
        height: 65px;
        //margin-left: 0px;
      
        
        &:nth-child(1) {
          height: 110px;

          @media all and (max-width: 1366px) {
            height: 80px;
          }
          @media all and (max-width: 540px) {
            height: 70px;
          }
        }
         &:nth-child(2) {
          height: 65px;

           @media all and (max-width: 1366px) {
            height: 50px;
          }
        }
         &:nth-child(3) {
          height: 60px;

          @media all and (max-width: 1366px) {
            height: 40px;
          }
        }

        &:last-child {
         height: 50px;
        
         @media all and (max-width: 1366px) {
            height: 45px;
          }
        }
        
        @media all and (max-width: 1366px) {
          height: 50px;
        }

         @media all and (max-width: 540px) {
          height: 35px;
        }

        img {
          height: 100%;
        }
      }
    }
  }

</style>
